import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';

import { array, bool, number } from 'prop-types';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import ConfirmButton from '../../../components/ConfirmButton';

import WizardStep from './WizardStep';
import WizardSummaryTable from './WizardSummaryTable';

import * as UiActions from '../../../actions/uiActions';
import * as WizardActions from '../../../actions/wizardActions';

import classes from './WizardPanel.module.css';

const WizardPanel = ({
    activeStep,
    createTargetEquipment,
    createTargetSensors,
    equipmentCreated,
    isLoading,
    resetWizard,
    sensorsCreated,
    setActiveStep,
    setAgentName,
    setEquipmentTypeName,
    setProfileName,
    setValidateForm,
    targetSensors,
    steps,
    toggleLoading,
    wizardComplete,
    ...props
}) => {
    const { selectedSite } = props;

    useEffect(() => {
        if (sensorsCreated) {
            setActiveStep(activeStep + 1);
        }
    }, [sensorsCreated]);

    useEffect(() => {
        if (activeStep === 4 && targetSensors.length) {
            setConfirmDisabled(false);
        } else if (activeStep === 4 && !targetSensors.length) {
            setConfirmDisabled(true);
        }
    }, [activeStep, targetSensors]);

    const [confirmDisabled, setConfirmDisabled] = useState(false);

    const handleReturnToArchitect = () => {
        const { companyInfo, history } = props;

        toggleLoading(false);
        resetWizard();
        history.push(`/architect?company=${companyInfo.companyId}`);
    };

    const handleBack = () => {
        if (activeStep) {
            setActiveStep(activeStep - 1);

            if (isLoading) {
                toggleLoading(false);
            }
        }
    };

    const handleNext = () => {
        setValidateForm(true);

        if (activeStep === 3 && !equipmentCreated) {
            if (!isLoading) {
                toggleLoading(true);

                createTargetEquipment();
            }
        } else if (activeStep === 5 && !sensorsCreated) {
            if (!isLoading) {
                toggleLoading(true);

                createTargetSensors();
            }
        } else if (activeStep >= 3) {
            setActiveStep(activeStep + 1);
        }
    };

    const renderPanel = () => {
        if (wizardComplete) {
            return (
                <div className={classes.wizardTable}>
                    <WizardSummaryTable />
                </div>
            );
        } else {
            let form;

            switch (activeStep) {
                case 0:
                case 1:
                case 2:
                    form = true;
                    break;
                case 3:
                case 4:
                case 5:
                    form = false;
                    break;
                default:
                    break;
            }

            return (
                <WizardStep
                    form={form}
                    selectedSite={selectedSite}
                />
            );
        }
    };

    const renderButtons = () => {
        if (wizardComplete) {
            return (
                <ConfirmButton
                    label="Return to Architect"
                    onClick={handleReturnToArchitect}
                />
            );
        }

        if (activeStep === 3 && equipmentCreated) {
            if (isLoading) {
                toggleLoading(false);
            }

            return (
                <React.Fragment>
                    <ConfirmButton
                        label="Return to Architect"
                        onClick={handleReturnToArchitect}
                    />
                    <ConfirmButton
                        label={renderLabel()}
                        onClick={handleNext}
                        isLoading={isLoading}
                    />
                </React.Fragment>
            );
        }

        if (activeStep === 0) {
            return (
                <ConfirmButton
                    disabled={confirmDisabled}
                    label={renderLabel()}
                    onClick={handleNext}
                    isLoading={isLoading}
                />
            );
        }

        return (
            <React.Fragment>
                <Button
                    onClick={handleBack}
                    className={classes.backButton}
                >
                    Back
                </Button>
                <ConfirmButton
                    disabled={confirmDisabled}
                    label={renderLabel()}
                    onClick={handleNext}
                    isLoading={isLoading}
                />
            </React.Fragment>
        );
    };

    const renderLabel = () => {
        if (activeStep === 3 && !equipmentCreated) {
            return 'Create Equipment';
        } else if (activeStep === 5 && !sensorsCreated) {
            return 'Create Sensors';
        }

        return 'Next';
    };

    return (
        <div className={classes.WizardPanel}>
            <Paper className={classes.content}>
                {renderPanel()}
                <div className={classes.buttons}>
                    {renderButtons()}
                </div>
            </Paper>
        </div>
    );
};

WizardPanel.defaultProps = {
    activeStep:       0,
    equipmentCreated: false,
    sensorsCreated:   false,
    steps:            [],
    targetEquipment:  [],
    targetSensors:    []
};

WizardPanel.propTypes = {
    activeStep:       number,
    equipmentCreated: bool,
    sensorsCreated:   bool,
    steps:            array,
    targetEquipment:  array,
    targetSensors:    array
};

const mapStateToProps = state => {
    return {
        activeStep:       state.wizard.activeStep,
        companyInfo:      state.companyInfo,
        equipmentCreated: state.wizard.equipmentCreated,
        isLoading:        state.ui.isLoading,
        sensorsCreated:   state.wizard.sensorsCreated,
        steps:            state.wizard.steps,
        targetEquipment:  state.wizard.targetEquipment,
        targetSensors:    state.wizard.targetSensors,
        wizardComplete:   state.wizard.wizardComplete
    };
};

const mapDispatchToProps = {
    ...UiActions,
    ...WizardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WizardPanel));
